export default __webpack_public_path__ + "static/media/header.3ce24e32.png";